/**
 * @class GLPIBackendProvider
 *  GLPI url : https://is.bimedia-it.com/tickets/plugins/webservices/
 */
function GLPIBackendProvider() {
    let GLPIUrl;

    /**
     * @param {String} url
     */
    this.setGLPIUrl = function(url) {
        GLPIUrl = url;
    };

    this.$get = [
        '$http',
        function($http) {
            let self = {};

            self.getGLPITickets = function(id) {
                return $http.get(GLPIUrl + 'glpi/tickets/' + id).then(function(res) {
                    return res.data;
                });
            };

            self.getGLPIProblems = function(id) {
                return $http.get(GLPIUrl + 'glpi/problem/' + id).then(function(res) {
                    return res.data;
                });
            };

            self.observe = function(ticketId) {
                return $http.get(GLPIUrl + 'glpi/ticket/' + ticketId + '/observe').then(function(res) {
                    return res.data;
                });
            }

            return self;
        }
    ];
}

angular.module('app.prospection.store.glpiBackend', []).provider('glpiBackend', GLPIBackendProvider);
